import React from "react";
import { Form, Col, Row } from "react-bootstrap";

import { getFormattedDate } from "../../../../../util/helpers";
import useValidation from "../../../../../util/useValidation";
import {
  alphaNumericWithSpecialCharacterPattern
} from "../../../../../constants/constants";

const OrganizationDetailsForm = ({
  organization,
  handleOnChangePersonalDetails
}) => {
  const { handleOnBlurValidation, errors } = useValidation();
  const handOnBlurInput = e => {
    handleOnBlurValidation(e);
  };
  return (
    <Form.Group as={Row} controlId="company1">
      <Col sm={3}>
        <Form.Label>Name</Form.Label>
        <Form.Control
          size="sm"
          required
          type="text"
          name="organizationName"
          value={organization.organizationName}
          onChange={e => {
            handleOnChangePersonalDetails(
              e,
              "organizationDetails",
              organization.id
            );
          }}
          onBlur={handOnBlurInput}
          isInvalid={errors.organizationName}
          pattern={alphaNumericWithSpecialCharacterPattern}
        />
        {errors.organizationName && (
          <Form.Control.Feedback type="invalid">
            {errors.organizationName.type === "required" && "Name is required"}
            {errors.organizationName.type === "pattern" &&
              "Invalid characters entered for Organization Name"}
          </Form.Control.Feedback>
        )}
      </Col>
      <Col sm={2}>
        <Form.Label>From (Date)</Form.Label>
        <Form.Control
          size="sm"
          required
          type="date"
          name="joiningDate"
          value={getFormattedDate(
            organization.joiningDate,
            undefined,
            "YYYY-MM-DD"
          )}
          onChange={e => {
            handleOnChangePersonalDetails(
              e,
              "organizationDetails",
              organization.id
            );
          }}
          onBlur={handOnBlurInput}
          isInvalid={errors.joiningDate}
        />
        {errors.joiningDate && (
          <Form.Control.Feedback type="invalid">
            {errors.joiningDate.type === "required" &&
              "Joining Date is required"}
          </Form.Control.Feedback>
        )}
      </Col>
      <Col sm={2}>
        <Form.Label>To (Date)</Form.Label>
        <Form.Control
          size="sm"
          required
          type="date"
          name="lastWorkingDate"
          value={getFormattedDate(
            organization.lastWorkingDate,
            undefined,
            "YYYY-MM-DD"
          )}
          onChange={e => {
            handleOnChangePersonalDetails(
              e,
              "organizationDetails",
              organization.id
            );
          }}
          onBlur={handOnBlurInput}
          isInvalid={errors.lastWorkingDate}
        />
        {errors.lastWorkingDate && (
          <Form.Control.Feedback type="invalid">
            {errors.lastWorkingDate.type === "required" &&
              "To (Date) is required"}
          </Form.Control.Feedback>
        )}
      </Col>
      <Col sm={3}>
        <Form.Label>Designation</Form.Label>
        <Form.Control
          size="sm"
          required
          type="text"
          name="jobTitle"
          value={organization.jobTitle}
          onChange={e => {
            handleOnChangePersonalDetails(
              e,
              "organizationDetails",
              organization.id
            );
          }}
          onBlur={handOnBlurInput}
          isInvalid={errors.jobTitle}
          pattern={alphaNumericWithSpecialCharacterPattern}
        />
        {errors.jobTitle && (
          <Form.Control.Feedback type="invalid">
            {errors.jobTitle.type === "required" && "Job Title is required"}
            {errors.jobTitle.type === "pattern" &&
              "Invalid characters entered for Job Title"}
          </Form.Control.Feedback>
        )}
      </Col>
      <Col sm={2}></Col>
    </Form.Group>
  );
};

export default OrganizationDetailsForm;
